import 'core-js/modules/es.array.fill'
import baseX from 'base-x'
import { Base64 } from 'js-base64'

// const base62 = baseX('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ')
let base62 = null

/**
 * 문자열을 base62 포맷으로 변환
 * @param str
 */
export const encodeBase62 = (str: string) => {
  if (!str) {
    return str
  }

  if (!base62) {
    base62 = baseX('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789')
  }

  return base62.encode(Buffer.from(str, 'utf-8'))
}

/**
 * base62 문자열을 평문으로 변경
 * @param str
 */
export const decodeBase62 = (str: string) => {
  if (!str) {
    return str
  }
  if (!base62) {
    base62 = baseX('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789')
  }
  return base62.decode(str).toString()
}

/**
 * 문자열을 base64 포맷으로 변환
 * @param str
 */
export const encodeBase64 = (str: string) => {
  if (!str) {
    return str
  }

  return Base64.encode(str)
}

/**
 * base64 문자열을 평문으로 변경
 * @param str
 */
export const decodeBase64 = (str: string) => {
  if (!str) {
    return str
  }
  return Base64.decode(str)
}
